// extracted by mini-css-extract-plugin
export default {"container":"KB-z","vocBtn":"LB-z","disabled":"MB-z"};